/** Takes the player to what a sticky-bar step names: scrolls it to the middle of the window (clear of the bar), focuses it and flashes its box once. */
export function reveal(target: HTMLElement | null): void {
  if (target === null) return;
  const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true;
  target.scrollIntoView?.({ block: "center", behavior: reduced ? "auto" : "smooth" });
  target.focus({ preventScroll: true });
  const box = target.closest<HTMLElement>("[data-reveal], article") ?? target;
  const gold = getComputedStyle(document.documentElement).getPropertyValue("--gold").trim() || "currentColor";
  if (!reduced && typeof box.animate === "function") box.animate([{ boxShadow: `0 0 0 3px ${gold}` }, { boxShadow: `0 0 0 3px transparent` }], { duration: 1400, easing: "ease-out" });
}
